module.exports = __webpack_public_path__ + "static/img/futu.191d2f8e.png";